import React, {Component} from "react";
import PrevArrow from "@common-images/prevArrow.svg";
import PrevArrowMob from "@common-images/prevArrowMob.svg";

export default class PrevBtn extends Component {

    clickHandler = () => {

        localStorage.setItem('duration', 'back')
        this.props.onClick()
    }

  render() {
    return (
      <div className="btn__prev" onClick={this.clickHandler}>
        <div className="btn__arrow">
          <img src={PrevArrow} alt="" />
        </div>
        <div className="btn__arrow-mobile">
          <img src={PrevArrowMob} alt="" />
        </div>
        <span>Назад</span>
      </div>
    );
  }
}
